import SectionFromInstanceConfig from '../SectionFromInstanceConfig';
import FlatItem from './FlatItem';

/**
 * Converts flat section data to deep nested format
 *
 * @param {Array<FlatItem>} flatItems
 * @return {Array<SectionFromInstanceConfig>}
 */
export default function flatItemsToInstanceConfigSections(flatItems: FlatItem[]): SectionFromInstanceConfig[] {
    const sections = [];

    let currentSection = {
        label: 'Section that wont be saved',
        rankedSkus: [],
        shouldPersist: false,
    };

    function stashCurrentSection() {
        if (currentSection.shouldPersist) {
            delete currentSection.shouldPersist;
            sections.push(currentSection);
        }
    }

    function newCurrentSection(headerLabel, shouldPersist) {
        currentSection = {
            label: headerLabel,
            rankedSkus: [],
            shouldPersist,
        };
    }

    flatItems.forEach((flatItem) => {
        switch (flatItem.type) {
            case 'persistentSectionHeader':
                stashCurrentSection();
                newCurrentSection(flatItem.value, true); // value is header label text
                break;
            case 'nonPersistentSectionHeader':
                stashCurrentSection();
                newCurrentSection('Section that wont be saved', false);
                break;
            case 'rankedSku':
                currentSection.rankedSkus.push(flatItem.value); // value is sku number
                break;
            default:
                throw new Error('Unrecognized flatItem.type: ' + flatItem.type);
        }
    });

    stashCurrentSection();

    return sections;
}
